import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapGenderTypes extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapGenderTypesOpened: false
       }
    }

    getGenderDisplayValue = (gender) => {

        let mappedGender = this.props.mapOptions.filter(option => option.value === gender.value);
        if (mappedGender.length > 0)
            return mappedGender[0].label;
        else
            return '';
    }

    render() {
        console.log(this.props)
        let { allGenderMapping } = this.props.mapGender;
        let {isMapGenderTypesOpened} = this.state;
        let noOfGenderTypesMapped = allGenderMapping.filter(genderMapping => genderMapping.column!=="").length;
    
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfGenderTypesMapped} of {allGenderMapping.length} values to gender types</Col>
                <Col sm="1" md="1" className={isMapGenderTypesOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapGenderTypesOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapGenderTypesOpened: !isMapGenderTypesOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapGenderTypesOpened}>
                 <div className="mt30">
                   {allGenderMapping.map((mappedGender, index) => {
                       console.log(mappedGender)
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                            {!mappedGender.value || mappedGender.value===undefined||mappedGender.value===null ||mappedGender.value==="null"|| mappedGender.value==="undefined"? 
                                mappedGender.value="empty"
                                :
                                mappedGender.value
                                }
                            </span>
                             {mappedGender.column!=="" ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>
                            {mappedGender.column.label}
                            </span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
